import reduceReducer from 'reduce-reducers';

import { Action } from '../../actions';
import { FeedFiltersState } from '../../typings/feedFilters';

import { PRIORITY_FORM_INITIAL_STATE, priorityFormReducer } from './priority-form';
import { RATE_FORM_INITIAL_STATE, rateFormReducer } from './rate-form';

const feedFiltersInitialState = {
    rateForm: RATE_FORM_INITIAL_STATE,
    priorityForm: PRIORITY_FORM_INITIAL_STATE
};

export function feedFiltersRootReducer(
    state: FeedFiltersState = feedFiltersInitialState,
    action: Action
): FeedFiltersState {
    const reducer = reduceReducer(rateFormReducer, priorityFormReducer);

    return reducer(state, action);
}
